import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

export default function ImageCarousel({ images }) {
  return (
    <div>
      <div className="hidden sm:flex flex-wrap">
        {images.map((image, idx) => {
          return (
            <div
              key={idx}
              className={`flex w-1/2 order-${idx} last:order-${
                idx - 2
              } md:last:order-${idx} md:w-1/4`}
            >
              <img src={image.src} alt={image.alt} className="w-full h-auto object-cover" />
            </div>
          );
        })}
      </div>
      <div className="sm:hidden">
        <p className="text-center text-red uppercase font-bold">
          Swipe to see more images
        </p>
        <Carousel
          showArrows={false}
          showIndicators={false}
          showStatus={false}
          showThumbs={false}
        >
          {images.map((image, idx) => {
            return (
              <div key={idx} className="flex h-full max-h-80">
                <img src={image.src} alt={image.alt} className="object-cover" />
              </div>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
}
